
import { ref, Ref } from "vue";
import { userService } from "@/service";
import { defineComponent } from "vue";

interface ListItem {
  house_id: string;
  house_numbers: string;
  true_place: string;
  house_user_type: "1" | "2";
  date_end: string;
  date_start: string;
  user_lists: Array<{
    name: string;
    mobile: string;
    house_user_type: string;
    house_user_type_name: string;
    id: string;
  }>;
}

export default defineComponent({
  setup() {
    const list: Ref<Array<ListItem>> = ref([]);
    const getList = async () => {
      const { data } = await userService.houseUser();
      list.value = data.data;
    };
    getList();

    const currentIndex = ref(0);
    const onChange = (index: number) => (currentIndex.value = index);

    return { list, onChange, currentIndex };
  }
});
